export default __webpack_public_path__ + "static/media/section_image.884a1a72.svg";